import { Actions, ActionTypes } from './actions';
import { State, initialState } from './state';
import { LoadingAction } from './loading-action.model';
import { get as _get } from 'lodash';

export function loadingReducer(state: State = initialState, action: Actions | LoadingAction) {
    const addLoadingKey = _get(action, 'loading.add', null);
    if (addLoadingKey) {
        state = {
            loadingKeys: [...state.loadingKeys.filter((key) => key !== addLoadingKey), addLoadingKey],
        };
    }

    const removeLoadingKey = _get(action, 'loading.remove', null);
    if (removeLoadingKey) {
        state = {
            loadingKeys: state.loadingKeys.filter((key) => key !== removeLoadingKey),
        };
    }

    if ((action as Actions).type === ActionTypes.CLEAR) {
        state = { loadingKeys: [] };
    }

    return state;
}
